module.exports = __webpack_public_path__ + "static/media/google.f97eb8f1.svg";